export default "__VITE_ASSET__ClQUsrjL__"